import React, { use, useEffect, useReducer, useState } from 'react';
import TextInput from '../../components/Common/TextInput';
import CallOut from '../../components/Common/CallOut';
import Notification from '../../components/Common/Notification';
import ActivityLoader from '../../components/Common/ActivityLoader';
import { useAccounts } from '../../DataStore/AccountsContext';
import ajaxExpenses from '../../util/remote/ajaxExpenses';
import { useTheme } from '../../DataStore/ThemeContext';
import { useIncomingInvoice} from '../../DataStore/IncomingInvoiceContext';


const reducer = (state, action)=>{
    if(action.type === "RESET"){
        return {...initialState}
    }
    return { ...state, [action.type]: action.value };
}

const initialState = {
    expenseAccount:'',
    paymentAccount:'',
    amount:'',
    description:'',
    transactionRef:'',
    transactionDate:'',
    payee:'',
    tag:'0',
    loading: false,
}


const SettleInvoice = ({invoice}) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const {paymentAccountListing, getPaymentAccounts} = useAccounts();
    const {setNotify, setSystemFunction} = useTheme();
    const {getInvoiceTransactions, getOutstandingInvoices, getUnpaidInvoiceCount} = useIncomingInvoice();

    const [info, setInfo] = useState(null);
    const [loading, setLoading] = useState(false);


    useEffect(()=>{
        getPaymentAccounts();
    }, []);

    useEffect(()=>{
          setSystemFunction(() => async () => await handleConfirm());
        return () => setSystemFunction(null);
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [state]);

   
    useEffect(()=>{
        if(info){
            setTimeout(() => {
                setInfo(null);
            }, 5000);
        }
    }, [info]);

    if(!invoice){
        return(
            <div className="card-body">
                <CallOut title="No invoice selected" description="Please select an invoice to settle"/>
            </div>
        )
    }

    const handleConfirm = async () =>{
       
        if(state.amount <= 0){
            setInfo(<Notification type='danger' message="Enter a valid amount."/>);
            return;
        }
        if(state.paymentAccount.length === 0){
            setInfo(<Notification type='danger' message="Select payment account."/>);
            return;
        }
        setLoading(true);
        const server_response = await ajaxExpenses.PayInvoice({
            "invoice_id":invoice.id,
            "payment_date":state.transactionDate,
            "amount":state.amount,
            "description":state.description,
            "cash_account":state.paymentAccount,
            "payment_ref": state.transactionRef
          }
        );
        setLoading(false);
        if(server_response.status==="OK"){
            setNotify(<Notification type='success' message={server_response.message} closable={false}/>);
            getInvoiceTransactions(true);
            getOutstandingInvoices(true);
            getUnpaidInvoiceCount(true);
            setInfo(<Notification type='success' message={server_response.message} closable={false}/>)
            dispatch({type: 'amount', value: ''});
        }else{
            setInfo(<Notification type='danger' message={server_response.message} closable={false}/>)
        }


    }


    const RenderPaymentAccount = () => {

        
            const options=[];
            if(Array.isArray(paymentAccountListing))
            {
                paymentAccountListing.map((item, key)=>
                    options.push({label:item.account_number + ' ' + item.account_name, value:item.account_id})
                )
            }
            return(
                <TextInput
                    type="select"
                    label="Payment Track Account"
                    placeholder="Select Account"
                    leftIcon="fa fa-bank"
                    options={options}
                    onChange={(item)=>dispatch({type: 'paymentAccount', value: item?.value})}
                    leftComponent={<i className="fa fa-bank link" onClick={()=>getPaymentAccounts(true)}></i>}
                    loading={!paymentAccountListing}
                    required
                    wrap
                    value={state.paymentAccount}
            />
    
            )
      }
    



    return (
        <>
            <CallOut 
                title={invoice.vendor.title} 
                description={"Reference: " + invoice.invoice_ref + " | Invoice Date: " + invoice.invoice_date + " | Description: "+ invoice.description + " | amount: " + invoice.amount}/>
                       
            <div className='mt-4'>{info}</div>
            <form className="form-horizontal" method="post" onSubmit={handleConfirm}>

                <TextInput
                    type="date"
                    label="Payment Date"
                    placeholder="Payment Date"
                    leftIcon="fa fa-calendar-alt"
                    value={state.transactionDate}
                    onChange={e => dispatch({type: 'transactionDate', value: e.target.value})}
                    required
                    wrap
                />

                            
                <TextInput
                    type="text"
                    label="Payment Ref"
                    placeholder="Payment Reference/Voucher No./Cheque No"
                    leftIcon="fa fa-hashtag"
                    value={state.transactionRef}
                    onChange={e => dispatch({type: 'transactionRef', value: e.target.value})}
                    required
                    wrap
                />

                <TextInput
                    type="text"
                    label="Amount Paid"
                    placeholder="Amount Paid"
                    leftIcon="fa fa-credit-card"
                    value={state.amount}
                    onChange={e => dispatch({type: 'amount', value: e.target.value})}
                    required
                    wrap
                    />
                    <TextInput
                        type="textarea"
                        label="Payment Description"
                        placeholder="Payment Description"
                        leftIcon="fa fa-list"
                        value={state.description}
                        onChange={e => dispatch({type: 'description', value: e.target.value})} 
                        required
                        wrap
                    />


                    {RenderPaymentAccount()}


            </form> 

        </>
    );
};

export default SettleInvoice;